
import '../music.css'
import { Form, Input, InputNumber, Button, Layout, Row, Col,Upload,notification, message,Modal, Checkbox, Select,ConfigProvider, Divider, Collapse,Menu,Spin    } from 'antd';
import { HomeOutlined,UploadOutlined,CheckOutlined, PlusOutlined, UserOutlined, MinusCircleOutlined} from '@ant-design/icons';
import React, { Component, Fragment } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import validator from 'validator';
import es_ES from 'antd/lib/locale/es_ES';
import countries from '../static/json/countries.json'
import {NavLink} from "react-router-dom";
import es from 'react-phone-input-2/lang/es.json'


class Inscription extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      authors:[],
      isBusy:false,
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/musica/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }

  async componentWillMount() {
    // const plays = await fetch('https://back.premiocasa.cult.cu/api/musica/obra/',{
    //   method: "get",
    //   credentials: "same-origin",
    //   headers: {
    //     "Authorization": localStorage.getItem("Authorization") ,
    //     "Accept": "application/json",
    //     "Content-Type": "application/json"
    // },
    // });
    // const json_plays = await plays.json();
    // if(json_plays['detail']){
    //   localStorage.clear()
    //   window.location.reload(); 
    // }
    // console.log("aqui")
    const response = await fetch('https://back.premiocasa.cult.cu/api/musica/genero/');
    const json = await response.json();
    console.log("GET",json)
    this.setState({ genres: json });
  }

  getCountryCode(country){
    for(var c in  countries["countries"]){
      if (countries["countries"][c]["name_es"]==country)
        return countries["countries"][c]["code"]
    }
    return "No code"
  }
  getCountryName(country){
    for(var c in  countries["countries"]){
      if (countries["countries"][c]["code"]==country)
        return countries["countries"][c]["name_es"]
    }
    return "No name"
  }

  render() {
    
    const layout = {
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },

    }

    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          offset: 1,
        },
        sm: {
          span: 4,
          offset: 8,
        },
      },
    };
    
    const validateMessages =  {
      
      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    
      
    }

    function addAuthors(formdata, users, name) {
      for (var i = 0; i < users.length; i++) {
        addSingleAuthor(formdata, users[i], name + "[" + i + "]");
      }
  }
  
  function addSingleAuthor(formdata, user, name) {
      for (var key in user) {
          formdata.append(name + "." + key,  user[key]);
      }
  }
  const readError = async(errm)=>{
    const errorm = await errm.json()
    return errorm
  }
  function clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}

    const customRequest = (form) => {
      
     if(!form['pdf']){
      notification.error({
        message:'Error',
        description:'Zip de la obra es requerido',
      });
      return
     }
     console.log("TIPO",form['pdf'].fileList[0]["originFileObj"].type)
     if(!form['pdf'].fileList[0]["originFileObj"].type.includes('zip')){
      notification.error({
        message:'Error',
        description:'El archivo subido no es un Zip',
      });
      return
     }
    
     form['pseudo'] = form['pseudo']? form['pseudo']:''
      const data= new FormData()
      var autores =  JSON.parse(JSON.stringify(form['autores'])); 
      var pdf = JSON.parse(JSON.stringify(form['pdf'])); 

      console.log("COPY",autores)

      for(var aut in  form['autores']){
        form['autores'][aut]['tel'] = '+' + form['autores'][aut]['tel']
        form['autores'][aut]['pais'] = this.getCountryCode(form['autores'][aut]['pais'])
        console.log(form['autores'][aut]['tel'])

      }
      // application/pdf
    //   form
    //   console.log(form['pdf'].fileList[0])
      form['pdf'] =  form['pdf'].fileList[0]["originFileObj"]
      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
          // addAuthors(data,form[key],'autores')
        }
        else{
          data.append(key, form[key]);
          console.log(key)
          console.log(form[key])
        }
    }
    for(var aut in  form['autores']){
      form['autores'][aut]['tel'] = form['autores'][aut]['tel'].replace('+','')
      form['autores'][aut]['pais'] = this.getCountryName(form['autores'][aut]['pais'])
      console.log("REESTABLECIDO")
      console.log(form['autores'][aut]['tel'])
      console.log(form['autores'][aut]['pais'])
    }
    data.append('premio',5)
    // form['pais'] =  this.getCountryCode(form['pais'])
    // if(form['pdf'].type != 'application/pdf')
  //   for (var value of data.values()) {
  //     console.log(value);
  //  }
  console.log("AHHHH")

  console.log( form)
      this.setState({isBusy:true},()=>axios.post('https://back.premiocasa.cult.cu/api/musica/register/', data).then((res) => {
        if (res.status == 200){
          this.setState({isBusy:false})
          Modal.success({
            content: 'Gracias por registrarse en el concurso',
            onOk:()=> window.open("/musicologia","_self")
          });
         
        } ;
      }).catch((err) => {
        this.setState({isBusy:false})
        // var m = readError(err)
        form.autores =autores
        console.log("AQUI")
        console.log(autores)
        console.log(form.autores)
        form.pdf = pdf
        
        notification.error({
          message:'Error',
          description:err.response.data.non_field_errors[0],
        });
        
      }))
      

  }
    
    const checkBoxChange = e =>{
      console.log(e.target.checked)
      this.setState({showRegistrate:e.target.checked})
    }
    const handlesubmit = (values) =>{
      console.log(values)
        axios.post(
          'https://back.premiocasa.cult.cu/api/PremioCasa2022/obra/register/',{
          data:values
        }).then((res) => {
          console.log(res)
              if (res.status == 200) {
                notification.success("data successfully updated!");
              }
              else{
                notification.error({
                  message:'Error',
                  description:'Ter was an error',
                  
                });
              }
            })
            .catch((err) => {
              
              console.log(err)
            });
    }
      const onFinish = (values) => {
        console.log(values);
      }
      const { Header, Footer, Content } = Layout;
      const { Option } = Select;
      const { fileList } = this.state;
      const props = {
        onRemove: file => {
          this.setState(state => {
            const index = this.state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            return {
              fileList: newFileList,
            };
          });
        },
        beforeUpload: file => {
          this.setState({
            fileList: [file],
          });
          return false;
        },
        fileList,
      };
      const { Panel } = Collapse;
      const hoverStyle = {
        color: '#000000',
        ':hover': {
          color: '#ffffff'
        }
      };

          console.log("GENERO",this.state.genres)
    return (

      <div className="page-container">
        <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
<Layout style={{backgroundColor:'white'}}>
<Row>
            <Col><NavLink to="/musicologia"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>

          <Row justify="start" >
            <Col span={24}>
            <Menu  mode="horizontal" style={{borderBottom:'none'}}>
                <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia"> Inicio</NavLink>
                </Menu.Item>
                
              </Menu>
            </Col>
          </Row>
          
          <Row justify="start" align="middle">
            <Col span={24}>
              <div style={{textAlign: 'center', fontWeight:'bold'}}> <Col span={24}><h1 className='title' style={{color:"black"}}>Inscripción</h1></Col></div>
            </Col>
          </Row>
          <Spin spinning={this.state.isBusy} >
          <Content>

          <Row  justify="center" align="middle" >
            <Col span={24}>
            
              <Form {...formItemLayout} id='regForm' name="nest-messages" onFinish={customRequest} validateMessages={validateMessages} layout = 'horizontal' initialValues={{autores: [""]}}>
              
              
              <Row  justify="center" align="middle" >
                <Col xs={{span:24, offset:0 }}sm={{span:24, offset:0 }}>
                  <Divider style={{fontWeight:'bold', width:10, fontSize:'medium'}} >CONCURSANTE</Divider>
                  <Form.List name="autores">
                  {(fields, { add, remove }) => (
                   <>
                  
                     {fields.map((field,index) =>( 
                       <>
                        <Row  justify="center" align="left" >
                                  
                                  <Col xs={{span:24, offset:2}}sm={{span:10}}>
                                    <p >{fields.length==1?"Autor ": "Autor " + (index+1)} </p> 
                                  </Col>
                                  
  
                        </Row>
                                <Row  justify="center" align="middle" >
                                  
                               

                                  <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[field.name, 'nombre']} fieldKey={[field.fieldKey, 'first']} label="Nombre completo" rules={[{ required: true, max: 120 }]}>
                                         <Input className='music-input' style={{width:'80%'}}/>
                                      </Form.Item>
                                  </Col>
                                </Row>
                              
                                <Row  justify="center" align="middle" >
                            <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                <Form.Item {...field} name={[field.name,'pais']} label="País" fieldKey={[field.fieldKey, 's']} rules={[{ required: true }]}>
                                <Select className='music-select' style={{width:'80%'}} showSearch >
                                  {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                    return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                                })}
                                  </Select>
                                </Form.Item>
                                </Col>
                                </Row>
                                
                                
                        
                                <Row  justify="center" align="middle" >
                            <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                <Form.Item {...field} name={[field.name, 'email']} label="Correo electrónico" rules={[{ type: 'email',  required: true }]}>
                                   <Input className='music-input' style={{width:'80%', border:'2px solid #ed7e8e'}} />
                                </Form.Item>
                                </Col>
                                </Row>
                                
                                <Row  justify="center" align="middle" >
                            <Col xs={{span:24, offset:2}}sm={{span:24, offset:0 }}>
                                <Form.Item {...field} name={[ field.name,'tel']} label="Teléfono" rules={[{ required: true }]}>
                                      <PhoneInput
                                      localization={es}
                                  country={'cu'}
                                  enableSearch={true}
                                  searchPlaceholder="Buscar"
                                  value={this.state.phone}
                                  autoFocus= {true}
                                  onChange={phone => this.setState({ phone })}
                                  placeholder ={"Número de teléfono"}
                                />
                                </Form.Item>
                                </Col>
                                </Row>
                                
                                <Row  justify="center" align="middle" >
                                  <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item {...field} name={[ field.name,'direccion']} label="Dirección postal"rules={[{ required: true, max: 300 }]}>
                                       <Input className='music-input'  style={{width:'80%', border:'2px solid #ed7e8e '}}/>
                                    </Form.Item>
                                  </Col>
                                </Row>
                                
                                <Row  justify="center" align="middle" >
                                  <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item {...field} name={[ field.name,'ficha']} label="Ficha bio-bibliográfica"rules={[{ required: true, max: 500 }]}>
                                       <Input.TextArea  className='music-input' placeholder='Máximo 500 caracteres' style={{width:'80%', border:'2px solid #ed7e8e '}} />
                                    </Form.Item>

                                  </Col>
                                </Row>
            
                                {fields.length != index + 1 && <br/>}
                                
                                {fields.length== index + 1 && 
                                <Row  justify="center" align="middle" >
                                  <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                                    <Form.Item >
                                      <Button type="dashed" onClick={() => add()}  icon={<PlusOutlined />} style={{color:'#ed7e8e'}}>
                                            Añadir autor
                                      </Button>

                                    { index >0 && <Button type="dashed" onClick={() => remove(field.name)}  icon={<MinusCircleOutlined />}>
                                            Eliminar autor
                                      </Button> 
                                    }

                                    </Form.Item>
                                        
                                  </Col>
                                </Row>}

                                        </>
                                        
                        ))}
                       
                   
                    </>

                    )}
              </Form.List>

                </Col>
              </Row>

             
                <Row  justify="center" align="middle" >
                <Divider style={{fontWeight:'bold', fontSize:'medium'}} >OBRA</Divider>
                
            <Col xs={{span:22, offset:2 }}sm={{span:24, offset:0 }}>
                <Form.Item name={['titulo']} label="Título de la obra"rules={[{ required: true, max: 200 }]}>
                   <Input className='music-input'  style={{width:'80%', border:'2px solid #ed7e8e '}}/>
                </Form.Item>
                </Col>
                </Row>
                <Row  justify="center" align="middle" >
                  <Col xs={{span:22, offset:2 }}sm={{span:24, offset:0 }}>
                    <Form.Item name={[ 'pseudo']} label="Seudónimo" rules={[{  max: 50 }]}>
                       <Input placeholder='Opcional' defaultValue=''  className='music-input' style={{width:'80%', border:'2px solid #ed7e8e '}}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row  justify="center" align="middle" >
                  <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                      
                      
                      <Form.Item  name={['pdf']} >
                      <Upload {...props}>
                          <Button   style={{color:'#ed7e8e'}}icon={<UploadOutlined  />}>Subir Zip de la obra</Button>
                      </Upload>
                      </Form.Item>
                    </Col>
                </Row>
                
            <Row  justify="center" align="middle" >
              <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                <Form.Item  >
                    <Checkbox onChange={checkBoxChange}>
                          Acepto los <NavLink to="/musicologia/terminos" >Términos y condiciones de uso</NavLink>
                        </Checkbox><br/>
                        <br></br>
                    <Button icon={<CheckOutlined/>}style={{backgroundColor:'#ed7e8e', borderColor:'lightpink', margin:'auto'}} type="primary" htmlType="submit" size='small' disabled={!this.state.showRegistrate}>
                      Registrarse
                    </Button>
                </Form.Item>
              </Col>
            </Row>
              </Form>
            </Col>
          </Row>
          </Content>
          
          </Spin>

          </Layout>
        </ConfigProvider>
    </div>
    <Footer style={{backgroundColor:'#ed7e8e', position:'relative',bottom:'0px',left:'0px',right:'0px'}}>
          
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#ed7e8e',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/musicologia/bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/musicologia/terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
          
        </Row>
        </Footer>
    </div>

    );
  }
}
export default Inscription;


